<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" fill="none">
        <path
            d="M11.8923 10.6744C12.107 10.4705 12.278 10.225 12.3949 9.95286C12.5117 9.68075 12.572 9.3877 12.572 9.09155C12.572 8.7954 12.5117 8.50235 12.3949 8.23024C12.278 7.95812 12.107 7.71262 11.8923 7.50869C11.4527 7.09148 10.8698 6.85889 10.2637 6.85889C9.65764 6.85889 9.0747 7.09148 8.63513 7.50869L7.00084 9.14298L5.36656 7.50869C4.92697 7.09148 4.34403 6.85889 3.73798 6.85889C3.13193 6.85889 2.54899 7.09148 2.10941 7.50869C1.89466 7.71262 1.72366 7.95812 1.60681 8.23024C1.48995 8.50235 1.42969 8.7954 1.42969 9.09155C1.42969 9.3877 1.48995 9.68075 1.60681 9.95286C1.72366 10.225 1.89466 10.4705 2.10941 10.6744L7.00084 15.4286L11.8923 10.6744Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.00056 5.14272C8.26292 5.14272 9.28627 4.11937 9.28627 2.857C9.28627 1.59464 8.26292 0.571289 7.00056 0.571289C5.73819 0.571289 4.71484 1.59464 4.71484 2.857C4.71484 4.11937 5.73819 5.14272 7.00056 5.14272Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
